import { reactive } from "vue";

const state = reactive({
  active: 0,
  visible: false,
  failed: false,
  title: "",
  message: "",
  category: "",
  startedAt: 0,
  elapsed: 0,
  deviceSlow: false,
});

const requests = new Map();
let sequence = 0;
let elapsedTimer = null;
let hideTimer = null;
let pendingFailure = null;
let previousTick = performance.now();

// Uma deriva grande do relógio indica que a thread da interface ficou bloqueada.
setInterval(() => {
  const now = performance.now();
  const drift = now - previousTick - 1000;
  state.deviceSlow = drift > 900;
  previousTick = now;
}, 1000);

function operationFor(config = {}) {
  const method = String(config.method || "get").toUpperCase();
  const endpoint = String(config.url || "").toLowerCase();

  if (endpoint.includes("reenviar-agt-lote")) {
    return {
      title: "A enviar documentos à AGT",
      message: "Os documentos estão a ser enviados sequencialmente. Não feche esta página…",
    };
  }
  if (endpoint.includes("/documentos") && method === "POST") {
    return {
      title: "A emitir documento",
      message: navigator.onLine
        ? "A validar os dados e a comunicar com a Facturação Electrónica…"
        : "Sem internet: a validar e guardar o documento localmente…",
    };
  }
  if (endpoint.includes("/series") && method === "POST") {
    return {
      title: "A solicitar séries",
      message: "A aguardar a resposta da AGT. Esta operação pode demorar…",
    };
  }
  if (endpoint.includes("/nif")) {
    return { title: "A consultar o NIF", message: "A consultar os dados fiscais…" };
  }
  if (endpoint.includes("pdf")) {
    return { title: "A preparar o documento", message: "A gerar o ficheiro para visualização…" };
  }
  if (method === "DELETE") {
    return { title: "A eliminar", message: "A concluir a operação com segurança…" };
  }
  if (["POST", "PUT", "PATCH"].includes(method)) {
    return { title: "A guardar alterações", message: "A processar e validar os dados…" };
  }
  return { title: "A carregar dados", message: "A obter a informação solicitada…" };
}

function slowMessage() {
  if (state.deviceSlow) {
    return "A interface está a responder lentamente. O computador pode estar sob carga elevada; aguarde sem repetir a acção.";
  }
  if (!navigator.onLine) {
    return "A ligação à internet foi interrompida. O pedido permanece à espera de comunicação.";
  }
  return "A resposta está a demorar mais do que o habitual. Pode existir lentidão na internet, no servidor ou na AGT.";
}

function runClock() {
  clearInterval(elapsedTimer);
  elapsedTimer = setInterval(() => {
    if (!state.active) return;
    state.elapsed = Math.max(0, Math.floor((Date.now() - state.startedAt) / 1000));
    if (state.elapsed >= 8) state.message = slowMessage();
  }, 1000);
}

function start(config) {
  clearTimeout(hideTimer);
  if (!requests.size) pendingFailure = null;
  const id = ++sequence;
  const operation = operationFor(config);
  requests.set(id, { ...operation, startedAt: Date.now() });
  updateActiveRequest();
  state.visible = true;
  if (state.active === 1) runClock();
  return id;
}

function updateActiveRequest() {
  const activeRequests = Array.from(requests.values());
  state.active = activeRequests.length;
  if (!state.active) return;

  const latest = activeRequests[activeRequests.length - 1];
  state.visible = true;
  state.failed = false;
  state.category = "loading";
  state.title = latest.title;
  state.message = latest.message;
  state.startedAt = latest.startedAt;
  state.elapsed = Math.max(0, Math.floor((Date.now() - latest.startedAt) / 1000));
}

function settle(id, diagnosis) {
  if (id == null || !requests.has(id)) return;

  requests.delete(id);
  if (diagnosis) pendingFailure = diagnosis;
  updateActiveRequest();
  if (state.active) {
    return;
  }

  clearInterval(elapsedTimer);
  clearTimeout(hideTimer);
  if (pendingFailure) {
    state.visible = true;
    state.failed = true;
    state.category = pendingFailure.category;
    state.title = pendingFailure.title;
    state.message = pendingFailure.message;
    pendingFailure = null;
    hideTimer = setTimeout(() => {
      if (!state.active) state.visible = false;
    }, 9000);
  } else {
    hideTimer = setTimeout(() => {
      if (!state.failed && !state.active) state.visible = false;
    }, 250);
  }
}

function finish(id) {
  settle(id);
}

function fail(id, diagnosis, notify = true) {
  settle(id, notify ? diagnosis : null);
}

function dismiss() {
  if (!state.active) {
    clearTimeout(hideTimer);
    state.visible = false;
    state.failed = false;
  }
}

export const requestActivity = { state, start, finish, fail, dismiss };
export { operationFor };
